<template>
	<DashboardCard 
        :header-title="formattedGroupName"
        :refresh-button="true"
        @refresh="refresh"
        @clear="addMembersToGroup"
    >
		<PaginatedTable :table-data="paginatedTableData"
		                :search-model="searchModel"
		                @options="actionPerformed"
		                @search="handleSearch"
		                @sort="(newContent)=>tableData={...newContent}"
		                @next="loadNextPage"
		                :extra-inputs="extraInputs"
                        :dateSearch="false"
		                @previous="loadPreviousPage"
		                :row-options="GroupOptions"
		                :table-headers="tableHeaders"/>
	</DashboardCard>
</template>

<script>
import DashboardContainer from "@/dashboard/containers/DashboardContainer.vue";
import DashboardCard from "@/dashboard/containers/DashboardCard.vue";
import PaginatedTable from "@/dashboard/utils/paginator/PaginatedTable.vue";
import {DEFAULT_PAGE} from "@/dashboard/utils/default_values";
import {GENDERS} from "@/dashboard/members/members";
import {MEMBER_SEARCH_MODEL} from "@/dashboard/organization/Organization";

export default {
    name: "ListPersonGroup",
    components: {PaginatedTable, DashboardCard, DashboardContainer},

    data(){
        return{
            categories : [],
            searchModel: {...MEMBER_SEARCH_MODEL},
            tableData: {...DEFAULT_PAGE},
            tableHeaders: {
                "Full name":{
                    rows:[
                        { type: "StringArray", attribute: ["firstName", "lastName"]},
                        { type: "Date", label:"DoB", attribute:"dob"},
                        { type: "String", label:"Code", attribute:"code"},
                    ]
                },
                "Gender":{
                    rows:[
                        { type: "Select", attribute: "gender", options:[...GENDERS]},
                    ]
                },
                "Address":{
                    rows:[
                        { type: "String", attribute: "addressLine3"},
                        { type: "String", attribute: "addressLine2"},
                        { type: "String", attribute: "addressLine1"},
                    ]
                },
            },
        }
    },

    computed: {
        GroupOptions () {
            return [
                { label : "Remove from the group", method: "delete", styleClass: "col-md-12 mb-4"},
            ]
        },

        paginatedTableData() {
            return {
                ...this.tableData,
                currentPage: this.tableData.number,
            }
        },

        extraInputs () {
            return [
                { type: "TEXTAREA", styleClass:"col-md-12 mb-4", model:"partnerCodes", placeholder: "Partner Codes" },
            ]
        },

        // ✅ CAPITALIZE TITLE HERE
        formattedGroupName() {
            if (!this.group || !this.group.name) return "Select a Group";
            return this.group.name.charAt(0).toUpperCase() + this.group.name.slice(1).toLowerCase();
        }
    },

    methods: {
        delete(row){
            let data  = {
                groupId : this.group.id,
                memberId : row.id
            }
            this.$api.post("/group/delete-member", data).then(response=>{
                this.$root['showAlert']("success", "Group", response.message);
                this.tableData = {
                    ...this.tableData,
                    totalElements: this.tableData.totalElements-1,
                    content: this.tableData.content.filter(item=>{
                        return item.id!==row.id;
                    })
                };
            }).catch(error=>{
                this.$root['handleApiError'](error ,"Group ");
            })
        },

        async refresh() {
            if (!this.group) {
                this.$root['showAlert']("warn", "Group", "Please select a group first!");
                return;
            }

            try {
                this.$store.commit("setLoading", true);

                this.searchModel = {
                    ...this.searchModel,
                    partnerCodes: null,
                    page: 1,
                    size: 10,
                    timeStamp: new Date().getTime(),
                };

                this.tableData = { 
                    ...this.tableData,
                    content: [],
                    totalElements: 0,
                    number: 0
                };

                await this.loadMembers(true);

                this.$root['showAlert']("success", "Group", "All filters cleared and data refreshed!");
            } catch (error) {
                this.$root['handleApiError'](error, "Group Refresh");
            } finally {
                this.$store.commit("setLoading", false);
            }
        },

        addMember(data) {
            this.$api.post("/group/add-member", data)
                .then(response => {
                    this.$root['showAlert']("success", "Group", "Member added successfully.");
                    this.loadMembers(); 
                })
                .catch(error => {
                    this.$root['handleApiError'](error, "Add Member");
                });
        },

        loadCategories(){
            let data = this.$root['addInstitutionId']({});
            this.$api.post("/category/get", data).then(response=>{
                this.categories = response.map(category=>{
                    return {
                        label: category.name,
                        value: category.id
                    }
                });
            }).catch(error=>{
                this.$root['handleApiError'](error, "Categories Loading");
            });
        },

        actionPerformed(value){
            this[value.method](value.row);
        },

        handleSearch(searchModel){
            const v = searchModel.partnerCodes;
           const originalCodes = searchModel.partnerCodes;

if (typeof searchModel.partnerCodes === "string" && searchModel.partnerCodes.trim() !== "") {

    searchModel.partnerCodes = searchModel.partnerCodes
        .split(/[\n,\t ]+/)  
        .map(code => code.trim())
        .filter(code => code.length > 0);


        
    // remove duplicates
    searchModel.partnerCodes = [...new Set(searchModel.partnerCodes)];

} else {
    searchModel.partnerCodes = null;
}

// keep UI value unchanged
this.searchModel.partnerCodes = originalCodes;

            this.searchModel = {...searchModel};
            this.loadMembers();
        },

        loadNextPage(){
            this.searchModel = {
                ...this.searchModel,
                page : this.searchModel.page+1
            }
            this.loadMembers();
        },

        loadPreviousPage(){
            this.searchModel = {
                ...this.searchModel,
                page : this.searchModel.page-1
            }
            this.loadMembers();
        },

        loadMembers(){
            if(this.group && this.$root['isInstitutionSet']()){
                const requestBody = this.$root['addInstitutionId']({
                    ...this.searchModel,
                    groupId :this.group.id
                });
                
                this.$api.post("/group/list-members", requestBody).then(response=>{
                    this.tableData = {
                        ...response,
                        totalElements: response.totalElements ?? 0,
                        number: response.number ?? 0
                    };
                    this.$root['showAlert']("success", "Group loading", "Loaded");
                }).catch(error=>{
                    this.$root['handleApiError'](error, "Group Loading");
                });
            }
        }
    },

    beforeMount(){
        this.loadCategories();
    },

    props:{
        listPersonDisabled : {
            type:Boolean,
            default(){
                return false;
            }
        },
        group:{
            type:Object,
            default(){
                return null
            }
        }
    },

    watch: {
        group(newGroup) {
            if (newGroup) {
                this.loadMembers();
            }
        }
    }
}
</script>
